<template>
  <div class="filter-sort">
    <section class="filter">
      <div class="filter-left">
        <span class="filter-name">{{ brand.nameCN }}</span>
        <span class="filter-enname">{{ brand.name }}</span>
        <span class="filter-name__tip">为你找到{{ total }}辆车</span>
      </div>
      <div class="filter-form__center"><a href="https://corp.yorkbbs.ca/ads" target="_blank">增加曝光率，可致电416-915-5056或加微信yorkbbstoronto</a> </div>
      <div class="filter-right">
        <button class="filter-button__option" @click="filterVisible = true">
          <i class="yk-filter"></i>
          <span>筛选</span>
        </button>
        <div class="sort-list">
          <button class="sort-item" :class="{ active: _sortType === 1 }" @click="onSortTypeChange(1)">推荐</button>
          <button class="sort-item" :class="{ active: _sortType === 2 }" @click="onSortTypeChange(2)">最新<img class="laster-new" height="12"     src="https://media6.imgyb.xyz/media/v1/image/9617a906f88c6e243ff6949aee3d6cca.png" alt=""></button>
          <button
            class="sort-item"
            :class="{ active: _sortType === 3 }"
            @click="onSortTypeChange(3)"
            v-show="priceUpVisible"
          >
            <span>价格</span>
            <i class="yk-forsale_up"></i>
          </button>
          <button
            class="sort-item"
            :class="{ active: _sortType === 4 }"
            @click="onSortTypeChange(4)"
            v-show="!priceUpVisible"
          >
            <span>价格</span>
            <i class="yk-forsale_down"></i>
          </button>
        </div>
      </div>
    </section>
    <!-- 筛选标签 -->
    <section class="tag-list" v-if="tagsVisible">
      <!-- 车主类型 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _sourceTags"
        :key="`source-${item.id}`"
        @close="onTagClose('source', item)"
      >
        {{ item.name }}
      </el-tag>
      <!-- 售价 -->
      <el-tag class="tag-item" effect="dark" type="info" closable v-if="_priceTag" @close="onTagClose('Price')">
        {{ _priceTag }}
      </el-tag>
      <!-- 年份 -->
      <el-tag class="tag-item" effect="dark" type="info" closable v-if="_yearTag" @close="onTagClose('year')">
        {{ _yearTag }}
      </el-tag>
      <!-- 现有公里数 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-if="_existingKMTag"
        @close="onTagClose('existingKM')"
      >
        {{ _existingKMTag }}
      </el-tag>
      <!-- 车型列表 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _mouldTags"
        :key="`mould-${item.id}`"
        @close="onTagClose('mould', item)"
      >
        {{ item.name }}
      </el-tag>
      <!-- 标签列表 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _tags"
        :key="`tags-${item.id}`"
        @close="onTagClose('tags', item)"
      >
        {{ item.name }}
      </el-tag>
      <!-- 变速箱列表 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _gearBoxTags"
        :key="`gearBox-${item.id}`"
        @close="onTagClose('gearBox', item)"
      >
        {{ item.name }}
      </el-tag>
      <!-- 燃油类型列表 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _fuelTypeTags"
        :key="`fuelType-${item.id}`"
        @close="onTagClose('fuelType', item)"
      >
        {{ item.name }}
      </el-tag>
      <!-- 驱动类型列表 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _drivingTypeTags"
        :key="`drivingType-${item.id}`"
        @close="onTagClose('drivingType', item)"
      >
        {{ item.name }}
      </el-tag>
      <!-- 配置列表 -->
      <el-tag
        class="tag-item"
        effect="dark"
        type="info"
        closable
        v-for="item in _configTags"
        :key="`config-${item.id}`"
        @close="onTagClose('config', item)"
      >
        {{ item.name }}
      </el-tag>
      <button class="tag-button__reset" @click="onTagsReset">
        <i class="yk-refresh"></i>
        <span>重置</span>
      </button>
    </section>
    <YorkbbsFilterDialog :data="options" :visible.sync="filterVisible" @change="onOptionsChange"></YorkbbsFilterDialog>
  </div>
</template>
<script>
import { existingKMOptions, years as yearConfigs } from '../components/data';
import YorkbbsFilterDialog from './dialog-filter.vue';
const years = yearConfigs.map(item => item.id).reverse();
export default {
  name: 'FilterSort',
  components: { YorkbbsFilterDialog },
  props: {
    // 汽车品牌名称
    brand: { type: Object },
    // 筛选出来的条目数
    total: { type: Number },
    // 排序类型
    sortType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // 价格上升排序显示状态
      priceUpVisible: true,
      // 筛选对话框显示状态
      filterVisible: false,
      options: {
        // 车主
        source: [],
        // 最低售价
        minPrice: undefined,
        // 最高售价
        maxPrice: undefined,
        // 年份
        year: [years[0], years[years.length - 1]],
        // 现有公里数，现在已经开了多少公里，单位km
        existingKM: [existingKMOptions.min, existingKMOptions.max],

        // 车型
        mould: [],
        // 标签：可邮寄等预定义标签
        tags: [],
        // 变速箱类型 1手动 2自动
        gearBox: [],
        // 燃油类型，1汽车，2柴油，3电动 4油电混合
        fuelType: [],
        // 驱动类型 1前驱；2后驱；3四驱；4全驱；
        drivingType: [],
        // 配置，支持多个
        config: [],
      },
    };
  },
  computed: {
    // 排序类型
    _sortType: {
      get: function() {
        return this.sortType;
      },
      set: function(val) {
        this.$emit('update:sortType', val);
      },
    },
    // 车主类型列表
    _sourceTags() {
      return this.options.source.filter(item => item.id !== 0);
    },
    // 售价标签
    _priceTag() {
      const { minPrice: min, maxPrice: max } = this.options;
      if (min === undefined) {
        return max === undefined ? false : `$${max}万以下`;
      } else {
        return max === undefined ? `$${min}万以上` : `$${min}万-$${max}万`;
      }
    },
    // 年份
    _yearTag() {
      const [min, max] = [...this.options.year];
      const MIN = years[0],
        MAX = years[years.length - 1];

      if (min == MIN) {
        if (max == min) {
          return `${min}年`;
        } else if (max == MAX) {
          return undefined;
        } else {
          return `${max}年以内`;
        }
      } else if (min == MAX) {
        return `${min}年以上`;
      } else {
        if (max == min) {
          return `${min}年`;
        } else if (max == MAX) {
          return `${min}年以上`;
        } else {
          return `${min}年-${max}年`;
        }
      }
    },

    // 现有公里数
    _existingKMTag() {
      const [min, max] = [...this.options.existingKM];
      const { min: MIN, max: MAX } = existingKMOptions;

      if (min == MIN) {
        if (max == min) {
          return '1万km以内';
        } else if (max == MAX) {
          return undefined;
        } else {
          return `${max}万km以内`;
        }
      } else if (min == MAX) {
        return `${min}万km以上`;
      } else {
        if (max == min) {
          return `${min}万km`;
        } else if (max == MAX) {
          return `${min}万km以上`;
        } else {
          return `${min}万km-${max}万km`;
        }
      }
    },
    // 车型列表
    _mouldTags() {
      return this.options.mould.filter(item => item.id !== 0);
    },
    // 标签列表
    _tags() {
      return this.options.tags.filter(item => item.id !== 0);
    },
    // 变速箱列表
    _gearBoxTags() {
      return this.options.gearBox.filter(item => item.id !== 0);
    },
    // 燃油类型列表
    _fuelTypeTags() {
      return this.options.fuelType.filter(item => item.id !== 0);
    },
    // 驱动类型列表
    _drivingTypeTags() {
      return this.options.drivingType.filter(item => item.id !== 0);
    },
    // 配置列表
    _configTags() {
      return this.options.config.filter(item => item.id !== 0);
    },
    // 标签列表显示状态
    tagsVisible() {
      return (
        this._sourceTags.length ||
        this._priceTag ||
        this._yearTag ||
        this._existingKMTag ||
        this._mouldTags.length ||
        this._tags.length ||
        this._gearBoxTags.length ||
        this._fuelTypeTags.length ||
        this._drivingTypeTags.length ||
        this._configTags.length
      );
    },
    // 筛选语句
    filterOptions() {
      let existingKMQuery;

      const [minExistingKM, maxExistingKM] = this.options.existingKM;
      if (!(minExistingKM == null && maxExistingKM == null)) {
        if (!(minExistingKM == existingKMOptions.min && maxExistingKM == existingKMOptions.max)) {
          if (minExistingKM == existingKMOptions.max) {
            existingKMQuery = { gt: minExistingKM * 10000 };
          } else {
            existingKMQuery = {
              gte: minExistingKM * 10000,
              lte: maxExistingKM * 10000,
            };
            if (maxExistingKM == existingKMOptions.max) delete existingKMQuery.lte;
          }
        }
      }

      return {
        source: this._sourceTags.map(item => item.id),
        mould: this._mouldTags.map(item => item.id),
        tags: this._tags.map(item => item.id),
        gearBox: this._gearBoxTags.map(item => item.id),
        fuelType: this._fuelTypeTags.map(item => item.id),
        drivingType: this._drivingTypeTags.map(item => item.id),
        config: this._configTags.map(item => item.id),
        price:
          this.options.minPrice == undefined && this.options.maxPrice == undefined
            ? undefined
            : {
                gte: this.options.minPrice && this.options.minPrice * 100 * 10000,
                lte: this.options.maxPrice && this.options.maxPrice * 100 * 10000,
              },
        year:
          this.options.year[0] == years[0] && this.options.year[1] === years[years.length - 1]
            ? undefined
            : {
                gte: this.options.year[0],
                lte: this.options.year[1],
              },
        existingKM: existingKMQuery,
      };
    },
  },
  watch: {
    sortType: {
      immediate: true,
      handler(sortType) {
        this.$emit('sort', sortType);
      },
    },
    options: {
      deep: true,
      handler() {
        this.$emit('filterChange', this.filterOptions);
      },
    },
  },
  methods: {
    /**
     * 筛选条件发生变化
     */
    onOptionsChange(data) {
      this.options = { ...data };
    },
    /**
     * 删除标签
     */
    onTagClose(type, data) {
      if (['MonthlySupply', 'Price'].includes(type)) {
        this.options[`min${type}`] = undefined;
        this.options[`max${type}`] = undefined;
      } else if (type == 'year') {
        this.options[type] = [years[0], years[years.length - 1]];
      } else if (type == 'existingKM') {
        this.options[type] = [existingKMOptions.min, existingKMOptions.max];
      } else {
        const index = this.options[type].findIndex(item => item.id === data.id);
        index > -1 && this.options[type].splice(index, 1);
      }
    },
    /**
     * 标签重置
     */
    onTagsReset() {
      Object.assign(this.options, this.$options.data().options);
    },
    /**
     * 排序发生变化
     */
    onSortTypeChange(value) {
      if (value === this._sortType) {
        if (value === 3) {
          this._sortType = 4;
          this.priceUpVisible = false;
          this.$emit('sortChange');
        } else if (value === 4) {
          this._sortType = 3;
          this.priceUpVisible = true;
          this.$emit('sortChange');
        }
      } else {
        this._sortType = value;
        this.$emit('sortChange');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-form__center{
  a{
    font-size: 14px; color: #e43a3a; text-decoration: none;
    &:hover{text-decoration: underline;}
  }
}
.filter-right {
  display: flex;
  align-items: center;
}
.filter-name {
  font-size: 24px;
  font-weight: 600;
}
.filter-enname {
  font-size: 20px;
  margin-left: 10px;
}
.filter-name__tip {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-9);
  margin-left: 8px;
}

.sort-item {
  height: 38px;
  background-color: #f8f8f8;
  padding: 0 20px;
  border: 0 none;
  font-size: 14px;
  position: relative;
  i {
    font-size: inherit;
  }
  &.active {
    background-color: rgba(228, 58, 58, 0.1);
    border-color: rgba(228, 58, 58, 0.1);
    color: rgb(228, 58, 58);
  }
  &:hover {
    opacity: 0.8;
  }
  &:first-child {
    border-radius: 4px 0 0 4px;
  }
  &:last-child {
    border-radius: 0 4px 4px 0;
  }
  & + .sort-item {
    margin-left: 1px;
  }
  .laster-new{
    position:absolute; top: -5px; right: 5px;
  }
}

.filter-button__option {
  background: #f8f8f8;
  border-radius: 4px;
  font-size: 14px;
  height: 40px;
  padding: 0 14px;
  color: var(--text-color);
  margin-right: 10px;
  border: 0 none;
  i {
    font-size: 14px;
    color: inherit;
    margin-right: 6px;
  }
  &:hover {
    opacity: 0.8;
  }
}

.tag-list {
  margin-top: 20px;
}

.tag-item {
  height: 40px;
  border: 0 none;
  line-height: 40px;
  background-color: #f8f8f8;
  color: var(--text-color);
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 10px;
  &.el-tag--dark.el-tag--info {
    ::v-deep {
      .el-tag__close {
        color: var(--text-color);
      }
    }
  }
}
.tag-button__reset {
  height: 40px;
  font-size: 14px;
  padding: 0 10px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: var(--text-color-6);
  i {
    margin-right: 3px;
    font-size: 14px;
  }
}
</style>
